import { OnInit, ElementRef, Host } from '@angular/core';
import { Directive, HostListener, Input } from '@angular/core';
import {UtilityService} from "../../services/utility/utility.service";
import * as _ from 'lodash';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[stickynoteable]'
})
export class StickynoteableDirective implements OnInit {
  @Input() stickynoteable: any;
  @Input('stickynoteableType') stickynoteableType: any = 'icon';
  @Input('stickynoteableText') stickynoteableText: any = this.stickynoteable;
  @Input('stickynoteableIcon') stickynoteableIcon: any = 'fa-sticky-note';
  public randomId = '';
  constructor(public element: ElementRef, private utilityService: UtilityService) {}

  ngOnInit(): void {
    if (this.stickynoteable) {
      this.randomId = this.utilityService.generateRandom();
      let el = this.element.nativeElement;
      el.classList.add('btn-link');
      let stickynoteableDom = document.createElement('i');
      if (this.stickynoteableType === 'icon') {
        stickynoteableDom.classList.add('fa');
        stickynoteableDom.classList.add(this.stickynoteableIcon);
      } else if (this.stickynoteableType === 'text') {
        stickynoteableDom.innerHTML = _.truncate(this.stickynoteableText, {
          'length': 50
        });
      }
      stickynoteableDom.style.cursor = 'pointer';
      stickynoteableDom.style['margin-right'] = '5px';
      stickynoteableDom.style['margin-top'] = '3px';
      stickynoteableDom.id = this.randomId;
      stickynoteableDom.dataset.toggle = 'tooltip';
      stickynoteableDom.title = this.stickynoteable;
      $(el).before($(stickynoteableDom));
      $('[data-toggle="tooltip"]').tooltip();
    }
  }

  onHover(domToAdd) {
    $(domToAdd).show();
  }

  onHoverOut(domToRemove) {
    $(domToRemove).hide();
  }
}
